module.exports = __webpack_public_path__ + "img/pekaway_100w.59e212e9.png";